import { Injectable } from "@angular/core";
import { PurchaseData, FeatureService } from "../shared";
import { ModalService } from "@bhtp-client-web/component";
import { BhtpBaseService, ApiQuoteResponse } from "@bhtp-client-api/base";
import { Http, RequestOptions } from "@angular/http";
import { GatewayErrorResponse } from "../shared/models/agents-gateway/errors/gateway-error-reesponse.model";
import { GWCreateInsuredEventRequest } from "../shared/models/agents-gateway/save-quote/gw-create-insured-event-request.model";
import { GWUpdateInsuredEventRequest } from "../shared/models/agents-gateway/save-quote/gw-update-insured-event-request.model";
import { GWInsuredEvent } from "../shared/models/agents-gateway/save-quote/gw-insured-event.model";
import { InsuredEventMapperV2 } from "../shared/helpers/insured-event.mapper-v2";
import { GWCreateInsuredEventResponse } from "../shared/models/agents-gateway/save-quote/gw-create-insured-event-response.model";
import { GWUpdateInsuredEventResponse } from "../shared/models/agents-gateway/save-quote/gw-update-insured-event-response.model";
import { FeatureToggles } from "../shared/models/agents-gateway/save-quote/feature-toggles.enum";
import { GWAttribute } from "../shared/models/agents-gateway/save-quote/gw-attribute.model";

@Injectable()
export class SaveQuoteService extends BhtpBaseService {
    constructor(private http: Http, private insuredEventMapper: InsuredEventMapperV2, private featureService: FeatureService) {
        super();
    }

    public async saveEvent(purchaseData: PurchaseData, quotes: ApiQuoteResponse[], saveMethod: string = 'Auto Saved', addToCart: boolean = true): Promise<GWCreateInsuredEventResponse> {
        let path: string = this.getFullUrl('/quote/event');
        let options: RequestOptions = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        const request: GWCreateInsuredEventRequest = new GWCreateInsuredEventRequest();
        request.event = this.convertPurchaseDataAndQuoteToEvent(purchaseData, quotes);

        this.addAttributesAndFeatureToggles(request, saveMethod, addToCart);

        try {
            let response: any = await this.http.post(path, request, options).toPromise();
            return JSON.parse(response._body);
        } catch (err) {
            this.handleGatewayError(err);
        }
    }

    public async updateEvent(purchaseData: PurchaseData, quotes: ApiQuoteResponse[], saveMethod: string = 'Auto Saved', addToCart: boolean = true): Promise<GWUpdateInsuredEventResponse> {
        let path: string = this.getFullUrl('/quote/event');
        let options: RequestOptions = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        const request: GWUpdateInsuredEventRequest = new GWUpdateInsuredEventRequest();
        request.event = this.convertPurchaseDataAndQuoteToEvent(purchaseData, quotes);

        this.addAttributesAndFeatureToggles(request, saveMethod, addToCart);

        try {
            let response: any = await this.http.put(path, request, options).toPromise();
            return JSON.parse(response._body);
        } catch (err) {
            this.handleGatewayError(err);
        }
    }

    private addAttributesAndFeatureToggles(request: GWCreateInsuredEventRequest | GWUpdateInsuredEventRequest, saveMethod: string, addToCart: boolean): void {
        // Add attributes to event
        if (!request.event.attributes) {
            request.event.attributes = [];
        }
        if (addToCart) {
            request.event.attributes.push(new GWAttribute('addCart', 'true'));
        }
        request.event.attributes.push(new GWAttribute('saveMethod', saveMethod));

        // Add attributes to each quote
        if (request.event.quotes) {
            request.event.quotes.forEach(quote => {
                if (!quote.attributes) {
                    quote.attributes = [];
                }
                if (addToCart) {
                    quote.attributes.push(new GWAttribute('addCart', 'true'));
                }
                quote.attributes.push(new GWAttribute('saveMethod', saveMethod));
            });
        }

        if (this.featureService.isEventIdAsQuoteNumberEnabled()) {
            const toggle = new FeatureToggles();
            toggle.name = 'featureToggleQuoteNumber';
            toggle.isEnabled = true;
            request.featureToggles = [toggle];
        }
    }

    private convertPurchaseDataAndQuoteToEvent(data: PurchaseData, quotes: ApiQuoteResponse[]): GWInsuredEvent {
        return this.insuredEventMapper.mapPurchaseDataAndQuoteToInsuredEvent(data, quotes);
    }

    private handleGatewayError(err: any) {
        let errorToThrow: GatewayErrorResponse;
        const body = err._body;
        if (body) {
            errorToThrow = JSON.parse(body);
        }
        else {
            errorToThrow = {
                message: 'Unknown Error',
                name: 'UNKNOWN_ERROR',
                validationMessages: []
            };
        }
        throw errorToThrow;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/quotes/save-quote.service.ts